import { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";

export function AppLightBoxGallery({files,openEl,setOpenEl}:any){

    const[open,setOpen] = useState(false);

    useEffect(()=>{
        if(openEl){
            setOpen(true);
        }else{
            setOpen(false);
        }
    },[files])


    function setMethod(el:any){

        setOpen(el)
        setOpenEl(el)
    }

    
    return(
        <>

        <Lightbox
        plugins={[Captions]}
          open={open}
          close={() => setMethod(false)}
          slides={files}
          
        />  
      </>

    )

}
